var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumDashboardCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 147,
    viewBox: "0 0 242 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4830_14338)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M241.645 126.408C241.411 129.842 239.421 133.158 235.948 136.358C232.709 139.284 228.222 142.094 222.682 144.708H19.9034C15.8065 141.976 12.2949 138.66 9.29045 134.563C8.23695 133.08 7.26149 131.559 6.40309 129.998C-18.8418 84.0342 41.1684 -3.8351 61.3409 0.495933C70.5883 2.48587 65.1257 22.5413 80.3819 32.2959C109.255 50.7125 164.427 1.66648 180.698 16.4154C189.399 24.2971 174.845 39.5143 180.269 62.8863C189.516 102.49 242.893 107.601 241.645 126.408Z",
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3648 112.986C31.2578 114 28.4095 111.776 27.278 110.879C25.5221 109.513 24.3906 107.913 20.996 100.578C17.8355 93.6717 17.9135 93.0865 18.1867 92.8524C19.2402 91.9159 23.2591 94.9984 29.0728 99.4464C33.6379 102.958 34.7695 104.363 35.2377 106.236C35.862 108.616 35.3938 112.049 33.3648 112.986Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0722 115.171C63.6821 116.107 59.0389 113.337 53.9275 114.859C49.0502 116.341 48.621 120.243 44.2509 120.711C42.4171 120.907 40.2711 120.399 38.9054 119.463C38.3201 119.034 37.8909 118.526 37.6959 117.98C36.7594 115.171 41.4026 110.489 46.2409 109.006C51.8205 107.289 56.9709 110.098 59.8583 111.659C60.7947 112.166 61.8482 112.83 62.7066 113.454C63.565 114.117 64.2283 114.781 64.0722 115.171Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3358 120.243C30.8676 121.141 28.2144 120.985 26.3025 120.126C25.1319 119.58 24.9368 119.073 24.1565 118.604C20.7619 116.693 15.3773 121.375 14.9872 120.868C14.597 120.321 19.2402 113.337 24.8978 114.195C28.8387 114.82 31.9601 118.995 31.3358 120.243Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7348 144.786H32.8575C30.5164 144.786 28.6436 142.874 28.6436 140.572L26.8097 124.34H43.7827L41.9488 140.572C41.9488 142.913 40.0759 144.786 37.7348 144.786Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.047 144.786H32.8575C30.5164 144.786 28.6436 142.874 28.6436 140.572L26.8097 124.34H28.1753L33.4038 140.572C34.1842 142.835 35.7059 144.786 38.047 144.786Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3403 124.457C34.8866 122.038 35.4328 118.448 33.9891 113.493C33.9111 113.22 33.8331 112.986 33.755 112.752C32.5064 109.006 28.9948 104.714 26.2245 101.319",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3402 124.457C35.7449 122.545 39.8418 117.629 44.9922 114.273C47.7625 112.479 49.7134 111.971 51.5083 111.932C52.8349 111.893 53.9274 112.166 54.6688 112.401",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3403 124.34C32.1553 121.336 29.8142 119.502 28.2924 118.487C25.6392 116.732 24.1175 116.536 23.2201 116.497C21.8544 116.458 20.7619 116.81 20.0596 117.122",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.695 49.0348C138.811 49.0348 142.148 45.6982 142.148 41.5822C142.148 37.4663 138.811 34.1297 134.695 34.1297C130.58 34.1297 127.243 37.4663 127.243 41.5822C127.243 45.6982 130.58 49.0348 134.695 49.0348Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.557 40.9189H140.743H127.477H121.663C120.688 40.9189 120.025 39.9825 120.337 39.0461L126.658 20.6684L127.087 19.3808C127.282 18.8346 127.711 18.4444 128.218 18.2883C128.374 18.2493 128.531 18.2103 128.687 18.2103H139.534C140.275 18.2103 140.899 18.6785 141.133 19.3418L147.884 39.007C148.196 39.9825 147.493 40.9189 146.557 40.9189Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.695 -10H133.525V18.2493H134.695V-10Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48 18.2493H129.74C129.74 16.8446 130.911 15.6741 132.315 15.6741H135.866C137.31 15.6741 138.48 16.8446 138.48 18.2493Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.557 40.9189H140.743H139.573C140.119 40.0996 141.719 39.9825 142.811 38.7729C145.972 35.1832 143.319 23.6338 135.32 19.732C134.774 19.4588 131.73 18.0542 128.257 18.2883C128.414 18.2493 128.57 18.2103 128.726 18.2103H139.573C140.314 18.2103 140.938 18.6785 141.173 19.3418L147.923 39.007C148.196 39.9825 147.493 40.9189 146.557 40.9189Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M85.5324 17.0007V76.5427C85.5324 79.6251 82.567 82.1613 78.9383 82.1613H33.1308C31.8041 82.1613 30.5946 81.8492 29.5801 81.2639C27.7853 80.2494 26.5757 78.5326 26.5757 76.5427V17.0007C26.5757 15.0498 27.7853 13.294 29.5801 12.2795C30.5946 11.6942 31.8432 11.3821 33.1308 11.3821H78.9383C82.567 11.4211 85.5324 13.9182 85.5324 17.0007Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M85.5324 34.5589V76.5817C85.5324 79.6641 82.567 82.2003 78.9383 82.2003H33.1307C29.502 82.2003 26.5366 79.6641 26.5366 76.5817V47.9813C29.8922 45.25 34.1062 42.9869 38.5543 43.3771C44.7582 43.8843 44.8362 48.8787 50.9621 50.2833C63.0188 53.0146 75.6997 36.9 85.5324 34.5589Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M29.7362 12.9038V80.6786C29.7362 80.8737 29.6971 81.0688 29.5801 81.2639C27.7853 80.2494 26.5757 78.5326 26.5757 76.5427V17.0007C26.5757 15.0498 27.7853 13.294 29.5801 12.2795C29.6971 12.4746 29.7362 12.6697 29.7362 12.9038Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M60.0533 12.5136V80.2884C60.0533 81.1078 59.273 81.7711 58.2975 81.7711H57.9854V11.4211H59.468C59.8192 11.6942 60.0533 12.0844 60.0533 12.5136Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5324 32.2959H26.5757V35.1052H85.5324V32.2959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5324 26.7163H26.5757V29.5256H85.5324V26.7163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5324 21.1366H26.5757V23.946H85.5324V21.1366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5324 15.557H26.5757V18.3663H85.5324V15.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9464 11.4211H54.1226V81.8102H57.9464V11.4211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M238.25 146.151C238.25 146.503 238.094 146.815 237.86 147.049C237.626 147.283 237.275 147.4 236.884 147.4H20.3327C19.5913 147.4 18.967 146.854 18.967 146.151C18.967 145.8 19.1231 145.488 19.3572 145.254C19.5913 145.02 19.9425 144.903 20.3327 144.903H236.884C237.626 144.903 238.25 145.449 238.25 146.151Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.524 97.8305L205.953 98.8257L212.239 121.378L215.81 120.382L209.524 97.8305Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.533 97.8077L205.943 98.8222L206.021 94.14L206.06 92.6573L206.879 93.9058L209.533 97.8077Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.918 93.9058L206.06 94.14V92.6573L206.918 93.9058Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.594 131.754L217.531 132.534L213.513 96.9883L220.575 96.2079L224.594 131.754Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51 97.6906C232.046 96.9493 232.319 94.6472 232.319 94.6472C233.256 90.3552 227.793 86.7655 227.793 86.7655C227.793 86.7655 228.027 89.8479 225.764 91.1355C223.54 92.4232 224.438 96.4811 225.569 96.7152",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.461 97.6156L225.614 96.7589L225.063 99.2344L228.909 100.091L229.461 97.6156Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.823 122.74C221.277 122.623 220.965 122.116 221.043 121.57L225.062 99.2123L228.925 100.071L223.072 122.038C222.877 122.545 222.37 122.896 221.823 122.74Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.393 115.522L223.384 145.176L223.345 145.293L223.306 145.41H212.849L207.192 115.522C207.114 115.054 207.348 114.664 207.738 114.469C207.777 114.429 207.855 114.429 207.933 114.39C208.011 114.351 208.089 114.351 208.167 114.351H228.418C229.081 114.351 229.549 114.937 229.393 115.522Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.384 145.254L223.345 145.371H212.888L207.231 115.483C207.153 115.015 207.387 114.625 207.777 114.429C207.816 114.39 207.894 114.39 207.972 114.351C212.303 124.574 214.098 131.285 214.917 135.812C215.151 137.216 215.581 139.908 217.688 142.172C219.365 144.044 221.511 144.864 223.384 145.254Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.802 84.9597V138.142H72.5985V84.9597C72.5985 80.5507 76.5784 77 81.4557 77H166.906C171.822 77 175.802 80.5507 175.802 84.9597Z",
    fill: "#31414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.095 138.844H76.2662V86.7156C76.2662 83.1649 79.1536 80.3166 82.6652 80.3166H165.657C169.208 80.3166 172.056 83.2039 172.056 86.7156V138.844H172.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.801 144.502H66.1605C64.4047 144.502 63 143.058 63 141.341C63 139.585 64.4437 138.181 66.1605 138.181H183.801C185.557 138.181 186.961 139.624 186.961 141.341C186.961 143.058 185.557 144.502 183.801 144.502Z",
    fill: "#31414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4045 58.7113C67.4511 58.7113 73.1635 52.9989 73.1635 45.9523C73.1635 38.9057 67.4511 33.1933 60.4045 33.1933C53.3579 33.1933 47.6455 38.9057 47.6455 45.9523C47.6455 52.9989 53.3579 58.7113 60.4045 58.7113Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4045 53.5609C61.6328 53.5609 62.6285 52.5651 62.6285 51.3368C62.6285 50.1085 61.6328 49.1128 60.4045 49.1128C59.1762 49.1128 58.1804 50.1085 58.1804 51.3368C58.1804 52.5651 59.1762 53.5609 60.4045 53.5609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1402 51.1417H54.6298C54.0445 51.1417 53.7323 50.4784 54.0445 50.0102L55.3321 48.2544C55.4491 48.0593 55.5272 47.8252 55.5272 47.6301V43.5332C55.5272 42.1285 56.0734 40.8409 56.9318 39.9045C57.7902 38.968 59.0388 38.4218 60.3655 38.4218C63.0187 38.4218 65.2037 40.7238 65.2037 43.5332V47.6301C65.2037 47.8642 65.2818 48.0983 65.3988 48.2544L66.6864 50.0102C67.0766 50.4784 66.7254 51.1417 66.1402 51.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M199.938 63.8767C207.084 63.8767 212.877 58.084 212.877 50.9384C212.877 43.7927 207.084 38 199.938 38C192.793 38 187 43.7927 187 50.9384C187 58.084 192.793 63.8767 199.938 63.8767Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.507 58.4077C193.76 58.6103 194.14 58.5849 194.343 58.3317L198.976 52.7361C199.179 52.4829 199.154 52.1031 198.9 51.9005C198.647 51.698 198.267 51.7233 198.065 51.9765L193.431 57.5721C193.229 57.8253 193.279 58.2051 193.507 58.4077Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.951 49.8496C201.154 50.0015 201.432 49.9509 201.584 49.7483L205.559 44.3046C205.711 44.1021 205.661 43.8235 205.458 43.6716C205.256 43.5197 204.977 43.5703 204.825 43.7729L200.85 49.2166C200.698 49.4192 200.749 49.6977 200.951 49.8496Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.964 52.7361C201.041 52.7361 201.913 51.8632 201.913 50.7865C201.913 49.7097 201.041 48.8368 199.964 48.8368C198.887 48.8368 198.014 49.7097 198.014 50.7865C198.014 51.8632 198.887 52.7361 199.964 52.7361Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.0001,
    y: 85,
    width: 86,
    height: 48,
    rx: 3,
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.083 115.667L111.25 100.083L119.042 107.167L124 98.6667L128.958 107.167L136.75 100.083L133.917 115.667H114.083ZM133.917 119.917C133.917 120.767 133.35 121.333 132.5 121.333H115.5C114.65 121.333 114.083 120.767 114.083 119.917V118.5H133.917V119.917Z",
    fill: "#FC9F55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4830_14338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 147,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumDashboardCard);
export default __webpack_public_path__ + "static/media/premium-dashboard-card.fa817840215438f9d8141bc4e439b9df.svg";
export { ForwardRef as ReactComponent };